module.exports = __webpack_public_path__ + "86103f24cc29c802df1f78623769704f.svg";